import { LENDI_BOT_IDENTITY } from '../../twilio';
import { analytics, ChatEventName, EventCategory } from '..';
// track first chat message and consecutive messages from each parties.
export var useSendMessageTracking = function (messages, userType, sender, channelSid) {
    var event;
    var isInitialMessage = messages.filter(function (x) { return x.authorIdentity !== LENDI_BOT_IDENTITY; }).length === 0;
    if (isInitialMessage) {
        event = {
            event_name: ChatEventName.FIRST_MESSAGE_SENT,
            category: EventCategory.CHAT,
            Channel_id: channelSid,
            user_type: userType,
            sender_id: sender.identity,
            time_to_message: new Date().toISOString(),
        };
    }
    else {
        event = {
            event_name: ChatEventName.MESSAGE_SENT,
            category: EventCategory.CHAT,
            Channel_id: channelSid,
            user_type: userType,
            sender_id: sender.identity,
            time_to_message: new Date().toISOString(),
        };
    }
    analytics(event);
};
//# sourceMappingURL=index.js.map